import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { captureException, withScope } from '@sentry/react';

const recentOperations: Array<{
    type: 'query' | 'mutation';
    timestamp: number;
    key?: string;
    variables?: any;
}> = [];

const MAX_HISTORY = 10;

const addOperation = (operation: (typeof recentOperations)[0]) => {
    recentOperations.push(operation);
    if (recentOperations.length > MAX_HISTORY) {
        recentOperations.shift();
    }
};

export const browserClient = new QueryClient({
    mutationCache: new MutationCache({
        onMutate: (_variables, mutation) => {
            addOperation({
                type: 'mutation',
                timestamp: Date.now(),
                key: mutation.options.mutationKey?.join('.'),
                variables: mutation.state.variables
            });
        },
        onError: (err, _variables, _context, mutation) => {
            withScope(scope => {
                scope.setContext('mutation', {
                    mutationId: mutation.mutationId,
                    variables: mutation.state.variables,
                    recentOperations: recentOperations
                });
                if (mutation.options.mutationKey) {
                    scope.setFingerprint(Array.from(mutation.options.mutationKey) as string[]);
                }
                captureException(err);
            });
        }
    }),
    queryCache: new QueryCache({
        onSuccess: (_, query) => {
            addOperation({
                type: 'query',
                timestamp: Date.now(),
                key: query.queryKey.join('.')
            });
        },
        onError: (err, query) => {
            withScope(scope => {
                scope.setContext('query', {
                    queryHash: query.queryHash,
                    recentOperations
                });
                scope.setFingerprint([query.queryHash.replaceAll(/[0-9]/g, '0')]);
                captureException(err);
            });
        }
    }),
    defaultOptions: {
        queries: {
            retry: window.Cypress ? false : 3
        }
    }
});
